import React from 'react';
import PropTypes from 'prop-types';

export default function Email({
  Field, Err, useInput, errors, prefill, focus,
}) {
  const fieldRef = React.useRef();

  React.useEffect(() => {
    if (prefill) {
      fieldRef.current.value = prefill;
    }
  }, [prefill]);

  React.useEffect(() => {
    fieldRef.current[focus ? 'focus' : 'blur']();
  }, [focus]);

  return (
    <React.Fragment>
      <Field
        ref={fieldRef}
        type="text"
        placeholder="email"
        {...useInput('email', {
          isRequired: true,
          isEmail: true,
        })}
      />
      {!!errors.email && (
        <Err>
          {{
            isRequired: 'Email address is required',
            isEmail: 'Email address is invalid',
          }[errors.email]}
        </Err>
      )}
    </React.Fragment>
  );
}

Email.propTypes = {
  Field: PropTypes.elementType.isRequired,
  Err: PropTypes.elementType.isRequired,
  useInput: PropTypes.func.isRequired,
  errors: PropTypes.shape({
    email: PropTypes.string,
  }),
  prefill: PropTypes.string,
  focus: PropTypes.bool,
};

Email.defaultProps = {
  errors: { email: null },
  prefill: null,
  focus: false,
};
